<template>
    <Table :pagination="false" stripe :tableData="detailsData" :class="{'table__column_size' : changeStyleColumns}">
        <template v-slot:head>
            <vs-th sort-key="name" class="column__advertiser" >{{i('global.Advertisers')}}</vs-th>
            <vs-th sort-key="leads_total" class="column__data" >{{i('global.Leads')}}</vs-th>
            <vs-th sort-key="deposits_total" class="column__data" >{{i('global.Deposits')}}</vs-th>
            <vs-th sort-key="conversion" class="column__data">%</vs-th>
        </template>

        <template v-slot:content="{content}">
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{ content.name ? content.name : '-' }}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{ content.leads_total }}</p>
            </vs-td>
            <vs-td class="cell__data">
                <p class="product-name font-medium truncate">{{ content.deposits_total }}</p>
            </vs-td>
            <vs-td class="cell__data">
                <div>
                    {{ Number(content.conversion).toFixed(2) }}
                </div>
            </vs-td>
        </template>
    </Table>
</template>

<script>
import Table from '@/components/custom-table/Table'
import i18n from '@/i18n/i18n'
export default {
    props: {
        detailsData: {
            type: Array,
            default() {
                return []
            }
        },
        changeStyleColumns: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Table
    },

    methods: {
        i(val) {
            return i18n.tc(val)
        }
    },
}
</script>